export default __webpack_public_path__ + "static/fingerprint-mug-2-312cd734fced854520243f064720517f.jpg";